import styled from 'styled-components'
import { tokens } from 'styling/tokens'

export const TabScroller = styled.div`
  margin-bottom: 1.5rem;
  overflow-x: auto;
`

export const NoAccessWrap = styled.div`
  max-width: 30rem;
  margin: 5rem auto;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
`

export const NoAccessIcon = styled.div`
  width: 3.5rem;
  height: 3.5rem;
  border-radius: 999px;
  display: grid;
  place-items: center;
  background: ${tokens.surface.inset};
  border: 1px solid ${tokens.border.hairline};
  color: ${tokens.text.muted};
  font-size: 1.5rem;
`

export const TaskHint = styled.span<{ $active?: boolean }>`
  font-size: ${tokens.font.label};
  font-weight: 600;
  color: ${(props) => (props.$active ? tokens.status.success.fg : tokens.text.muted)};
`

export const Ribbon = styled.div`
  display: flex;
  align-items: center;
`

export const RibbonStep = styled.div`
  text-align: center;
  flex: 1;
`

export const RibbonNode = styled.div<{ $state: 'done' | 'current' | 'todo'; $color: string }>`
  width: 1.875rem;
  height: 1.875rem;
  border-radius: 999px;
  margin: 0 auto 0.45rem;
  display: grid;
  place-items: center;
  font-size: ${tokens.font.label};
  font-weight: 700;
  background: ${(props) =>
    props.$state === 'done' ? tokens.status.success.fg : props.$state === 'current' ? props.$color : tokens.surface.inset};
  color: ${(props) => (props.$state === 'todo' ? tokens.text.muted : tokens.accent.ink)};
`

export const RibbonLabel = styled.div<{ $on?: boolean }>`
  font-size: ${tokens.font.micro};
  font-weight: ${(props) => (props.$on ? 700 : 500)};
  color: ${(props) => (props.$on ? tokens.text.primary : tokens.text.muted)};
`

export const RibbonBar = styled.div<{ $done?: boolean }>`
  flex: 0.6;
  height: 2px;
  margin-top: 0.9rem;
  background: ${(props) => (props.$done ? tokens.status.success.fg : tokens.border.hairline)};
`

export const StepBlock = styled.div`
  margin-bottom: 1rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid ${tokens.border.hairline};

  &:last-child {
    border-bottom: none;
    padding-bottom: 0;
    margin-bottom: 0;
  }
`

export const StepHead = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  margin-bottom: 0.5rem;
`

export const StepName = styled.span<{ $done?: boolean }>`
  font-size: ${tokens.font.micro};
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: ${(props) => (props.$done ? tokens.text.primary : tokens.text.muted)};
`

export const StepMeta = styled.span`
  font-size: ${tokens.font.micro};
  color: ${tokens.text.muted};
`

export const FieldGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.5rem 1.25rem;
`

export const FieldLabel = styled.div`
  font-size: ${tokens.font.micro};
  color: ${tokens.text.muted};
`

export const FieldValue = styled.div`
  font-size: ${tokens.font.body};
  font-weight: 600;
  color: ${tokens.text.primary};
  margin-top: 0.1rem;
`

export const HiddenStep = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: ${tokens.surface.inset};
  border: 1px solid ${tokens.border.hairline};
  border-radius: ${tokens.radius.control};
  padding: 0.6rem 0.7rem;
  font-size: ${tokens.font.label};
  color: ${tokens.text.muted};
`

export const CalcLine = styled.div<{ $highlight?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 0;
  ${(props) => props.$highlight && `border-top: 1px solid ${tokens.border.hairline}; margin-top: 0.25rem;`}
`

export const CalcFormula = styled.div`
  font-size: ${tokens.font.micro};
  font-family: monospace;
  color: ${tokens.text.muted};
  margin-top: 0.1rem;
`

export const KpiGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(11rem, 1fr));
  gap: 0.75rem;
  margin-bottom: 1.5rem;
`

export const Grid2 = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  align-items: start;

  @media (max-width: 70rem) {
    grid-template-columns: 1fr;
  }
`

export const BreakdownRow = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 0.25rem 0.75rem;
  align-items: center;
  margin-bottom: 0.875rem;

  &:last-child {
    margin-bottom: 0;
  }
`

export const ListLine = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.625rem 0;
  border-bottom: 1px solid ${tokens.border.hairline};
  cursor: pointer;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background: ${tokens.surface.glass};
  }
`

export const ConfigOption = styled.button<{ $active?: boolean }>`
  flex: 1;
  text-align: left;
  padding: 1rem;
  border-radius: ${tokens.radius.control};
  cursor: pointer;
  transition: all 0.15s ease;
  background: ${(props) => (props.$active ? tokens.accent.soft : tokens.surface.inset)};
  border: 1px solid ${(props) => (props.$active ? tokens.accent.base : tokens.border.hairline)};
`

